(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alcazia-site-style"] && !Shopify.designMode) return;
  try {
    function alcaziaNavigationAccessibility() {
    const menu = document.querySelector('#alcazia-mobile-menu');
    const opener = document.querySelector('.header__actions_btn--menu');
    const closer = menu?.querySelector('.offcanvas__close_btn');
    if (!menu || !opener || !closer || menu.dataset.alcaziaAccessible) return;
    menu.dataset.alcaziaAccessible = 'true';
    menu.setAttribute('role', 'dialog');
    const sync = () => {
      const open = menu.classList.contains('open');
      const focusWasInside = menu.contains(document.activeElement);
      opener.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-hidden', String(!open));
      menu.inert = !open;
      if (open) {
        menu.setAttribute('aria-modal', 'true');
        closer.focus({ preventScroll: true });
      } else {
        menu.removeAttribute('aria-modal');
        if (focusWasInside) opener.focus({ preventScroll: true });
      }
    };
    new MutationObserver(sync).observe(menu, { attributes: true, attributeFilter: ['class'] });
    menu.addEventListener('keydown', event => {
      if (!menu.classList.contains('open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closer.click();
      }
      if (event.key !== 'Tab') return;
      const focusable = [...menu.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"]')].filter(element => element.getClientRects().length);
      const first = focusable[0];
      const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alcaziaNavigationAccessibility, { once: true });
  else alcaziaNavigationAccessibility();
  document.addEventListener('shopify:section:load', alcaziaNavigationAccessibility);
  } catch(e) { console.error(e); }
})();

})();
